<template>
  <div id="Software">
    <img
      src="@/assets/images/pic200-20.svg"
      style="width: 100%; height: auto"
      alt=""
    />
    <div class="flex">
      <div class="text">
疾控大数据集成平台通过数据采集及 API 主动推送方式将来源于医疗卫生机构传染病、死因等相关数据，通过标准化分类的数据集进行统一数据采集，实现医疗健康和公共卫生领域内的数据交换和共享，整合业务数据，保证各部门之间的业务协同和保持共享数据的一致性。再根据不同的业务机构的传染病数据需求，开放数据交换与共享接口（API），根据国家统一数据交换平台统一数据交换接口，实现传染病、慢病、免疫规划等数据、平台基础资源数据（机构编码、地区编码、疾病分类代码等）的实时釆集交换，为行业各应用系统提供数据服务。      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 40px;
  text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution5.vue